import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { ExecuteChecklistQuestionPreviewComponent } from 'src/app/features/bizzmine/form/components/controls/edit-checklist-control/components/execute-checklist-question-preview/execute-checklist-question-preview.component';
import { IconComponent } from 'src/app/shared/components/ui/icon/icon.component';

@Component({
  selector: 'bizz-execute-checklist-preview',
  standalone: true,
  imports: [
    TranslatePipe,
    ExecuteChecklistQuestionPreviewComponent,
    IconComponent
  ],
  templateUrl: './execute-checklist-preview.component.html',
  styleUrl: './execute-checklist-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExecuteChecklistPreviewComponent {
  public canSave: InputSignal<boolean> = input.required<boolean>();
  public mode: InputSignal<'select' | 'save' | 'invalidChecklistsLicense'> = input.required<'select' | 'save' | 'invalidChecklistsLicense'>();
  public onSave: OutputEmitterRef<Event> = output<Event>();

  //Show loading animation
  public loading: InputSignal<boolean> = input<boolean>(false);
}
